import React from "react";
import { useSearchParams } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Users, Cloud, Tag, FolderTree, Plug, Building2, Mail, Sparkles } from "lucide-react";
import UsersPanel from "@/pages/settings/UsersPanel";
import MetadataCatalogPanel from "@/pages/settings/MetadataCatalogPanel";
import ArborescencesPanel from "@/pages/settings/ArborescencesPanel";
import DrivePanel from "@/pages/settings/DrivePanel";
import IntegrationsPanel from "@/pages/settings/IntegrationsPanel";
import SocietesPanel from "@/pages/settings/SocietesPanel";
import EmailTemplatesPanel from "@/pages/settings/EmailTemplatesPanel";
import OcrPanel from "@/pages/settings/OcrPanel";

const TABS = [
  { key: "users",          label: "Utilisateurs",   icon: Users,       testid: "tab-users" },
  { key: "societes",       label: "Sociétés",        icon: Building2,   testid: "tab-societes" },
  { key: "metadata",       label: "Métadonnées",     icon: Tag,         testid: "tab-metadata" },
  { key: "arborescences",  label: "Arborescences",   icon: FolderTree,  testid: "tab-arborescences" },
  { key: "emails",         label: "Emails",          icon: Mail,        testid: "tab-emails" },
  { key: "ocr",            label: "OCR",             icon: Sparkles,    testid: "tab-ocr" },
  { key: "drive",          label: "Drive",           icon: Cloud,       testid: "tab-drive" },
  { key: "integrations",   label: "Intégrations",    icon: Plug,        testid: "tab-integrations" },
];

export default function Settings() {
  const [params, setParams] = useSearchParams();
  const active = TABS.find((t) => t.key === params.get("tab"))?.key || "users";

  const setActive = (key) => {
    params.set("tab", key);
    setParams(params, { replace: true });
  };

  return (
    <div className="min-h-screen">
      <PageHeader
        title="Paramètres"
        subtitle="Gestion des utilisateurs, des métadonnées, des arborescences et de la synchronisation"
        index="06"
      />
      <div className="border-b border-zinc-200 bg-white sticky top-[89px] z-[5]">
        <div className="px-6 md:px-10 flex overflow-x-auto">
          {TABS.map((t) => {
            const isActive = active === t.key;
            return (
              <button
                key={t.key}
                data-testid={t.testid}
                onClick={() => setActive(t.key)}
                className={`relative inline-flex items-center gap-2 px-4 py-4 text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive ? "text-[#002FA7]" : "text-zinc-500 hover:text-zinc-900"
                }`}
              >
                <t.icon size={14} strokeWidth={1.5} />
                {t.label}
                {isActive && (
                  <span className="absolute left-0 right-0 bottom-[-1px] h-[2px] bg-[#002FA7]" />
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="p-6 md:p-10">
        {active === "users" && <UsersPanel />}
        {active === "societes" && <SocietesPanel />}
        {active === "metadata" && <MetadataCatalogPanel />}
        {active === "arborescences" && <ArborescencesPanel />}
        {active === "emails" && <EmailTemplatesPanel />}
        {active === "ocr" && <OcrPanel />}
        {active === "drive" && <DrivePanel />}
        {active === "integrations" && <IntegrationsPanel />}
      </div>
    </div>
  );
}
